const titulos={
    VentanaCrear:"Detalles de paquete",
}

const notificaciones={
    creacion:"Paquete Creado",
    modificacion:"Paquete Modificado",
    eliminacion:"Paquete Eliminado",
}

export {titulos,notificaciones}